import React, { useContext, useEffect, useState } from 'react'
import { 
  Container,
  HeaderDiv,
  HeaderText,
  InputDiv,
  InputLabel,
  StyledOption,
  StyledSelect,
} from './style'
import SideDropdownArrow from './SideDropdownArrow'
import CertificatesContext, {CertificateObject} from '../../../../../contexts/CertificatesContext'
import axios from 'axios'

const MoreOptionsFields: React.FC = () => {
  const [ isOpen, setIsOpen ] = useState(false)
  const { certificate, setCertificate } = useContext(CertificatesContext)
  const [ otherTypes, setOtherTypes ] = useState<{id: number, typeName: string, certificates:CertificateObject[]}[]>([])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_CERTIFICATES_BASE_URL}/certificate-type/with-certificates`)
      .then((response) => {
        if(response.data) setOtherTypes(response.data)
        return
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])
  
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value, name } = e.target
    setCertificate((prevCertificate) => ({
      ...prevCertificate,
      [name]: value
    }))
  }

  return (
      <Container>
        <HeaderDiv onClick={() => setIsOpen(!isOpen)}>
          <SideDropdownArrow isOpen={isOpen} onChange={() => setIsOpen(!isOpen)}/>
          <HeaderText>Mais opções</HeaderText>
        </HeaderDiv>
        {isOpen ? 
          otherTypes.map((item, index) => (
            <InputDiv key={index}>
              <InputLabel>{item.typeName}</InputLabel>
              <StyledSelect
                name={item.typeName}
              >
                <StyledOption defaultValue=''>Selecione</StyledOption>
                {item.certificates.map((certificate, index) => (
                  <StyledOption
                    key={index}
                    value={certificate.id}
                  >
                    {certificate.id}
                  </StyledOption>
                ))}
              </StyledSelect>
            </InputDiv>
          ))
        : null}
      </Container>
  )
}
export default MoreOptionsFields
